const fa = {
  10000001: 'SuperEx جشن دو سالگی',
  10000002: 'برای جوایز عالی وارد شوید!',
  10000003: 'با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 10000 USDT بزرگتر باز می شود.',
  10000004: 'جشن دو سالگی SuperEx',
  10000005: 'برنده 20000 USDT در رقابت معاملات آتی',
  10000006: 'رویداد  حجم معاملات: بالاترین جایزه <span style="color: #ffc72b;">10,000</span> USDT را باز کنید.',
  10000007: 'قهرمانی آینده',
  10000008: 'در رقابت معاملات آتی USDT برنده 20000',
}
export default fa



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/fa.js